import styled from "@emotion/styled";
import Translate from "src/ui/components/Translate/Translate";
import StepList, { Step } from "src/ui/components/StepList/StepList";
import { getHeadingProps } from "src/lib/useFocusHeading";

const StepsWrapper = styled.div`
  label: OnboardingStepsWrapper;
  margin: 0 auto;
  max-width: var(--content-width);
`;

const Title = styled.h1`
  font-size: var(--title-font-size, 2.25rem);
  margin-bottom: 0.5em;
  text-align: left;
`;

const StepListWrapper = styled.div``;
const TopSection = styled.div``;

type ExpectationStepsProps = {
  steps: Step[];
};

const ExpectationSteps = ({ steps }: ExpectationStepsProps) => {
  return (
    <StepsWrapper>
      <TopSection>
        <Title {...getHeadingProps()}>
          <Translate msg="onboardingExpectation.title" />
        </Title>

        <StepListWrapper>
          <StepList steps={steps} />
        </StepListWrapper>
      </TopSection>
    </StepsWrapper>
  );
};

export default ExpectationSteps;
